import * as React from 'react'
import { Spacer } from '../../../common/src/components/core'
import styled from '../../../common/src/components/styled'
import { FetchAgentVirtualTourQuery } from '../../../common/src/types.gen'
import NextVirtualAppointmentInfoDescription from './NextVirtualAppointmentInfoDescription'
import NextVirtualAppointmentInfoTitle from './NextVirtualAppointmentInfoTitle'

const Root = styled.div({})

const Border = styled.div({
  background: '#d8d8d8',
  width: 320,
  height: 1,
  margin: '0 auto',
})

interface NextVirtualAppointmentInfoProps {
  now: Date
  calendarLink: string
  showing?: NonNullable<FetchAgentVirtualTourQuery['agentVirtualTour']>['showing'] | null
}

const NextVirtualAppointmentInfo = (props: NextVirtualAppointmentInfoProps) => {
  const { now, calendarLink, showing } = props

  return (
    <Root>
      <NextVirtualAppointmentInfoTitle now={now} showing={showing} />
      <Spacer height={8} />
      <Border />
      <Spacer height={8} />
      <NextVirtualAppointmentInfoDescription calendarLink={calendarLink} showing={showing} />
    </Root>
  )
}

export default NextVirtualAppointmentInfo
